var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('v-img',{attrs:{"contain":"","src":_vm.anno.photoURL,"max-height":"200"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }